import forIn from "lodash/fp/forIn";
import isNil from "lodash/fp/isNil";

class Controller {
  constructor($mdDialog, $injector, ride) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.Captain = $injector.get("Captain");
    this.Events = $injector.get("Events");
    this.Bus = $injector.get("Bus");
    this.ride = ride;
    this.rideCity = ride.city.value;

    this.updateCaptainEvent = this.Events.getUpdateEvent("updateCaptain");
    this.updateBusTypeEvent = this.Events.getUpdateEvent("updateBusType");
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.confirmEvent = this.Events.getUpdateEvent("confirmEvent");

    this.captainInfo = {};
  }

  $onInit() {
    this.Events.on(this.confirmEvent, this.confirm.bind(this));

    if (!isNil(this.ride.captain) && isNil(this.ride.captain._id)) {
      this.noReasons = true;
      this.captainInfo.reason = null;
    }

    this.Events.on(this.updateCaptainEvent, this.clearFields.bind(this));
    this.Events.on(this.updateBusTypeEvent, this.getCaptainBuses.bind(this));
  }

  confirm() {
    const noCapForIn = forIn.convert({ cap: false });
    const selected = {};
    noCapForIn((value, key) => {
      selected[key] = (value && value._id) || value;
    })(this.captainInfo);

    this.$mdDialog.hide({ ...selected });
  }

  close() {
    this.$mdDialog.cancel();
  }

  getCaptainBuses({ _id }) {
    const {
      captainInfo: {
        captain: { _id: captainId, company, contractor },
      },
    } = this;

    const payload = {
      captain: captainId,
      type: _id,
      limit: 100,
    };

    if (company) {
      payload.company = company;
      payload.supply_category = "company";
    }
    if (contractor) {
      payload.supply_category = "contractor";
    }

    this.Bus.getAll(payload).$promise.then(
      (response) => {
        this.buses = response.hits.map((bus) => bus._source);
        this.captainInfo.bus = this.buses.find(
          (bus) => bus._id === this.ride.bus._id
        );
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  clearFields() {
    this.captainInfo.bus_type = null;
    this.captainInfo.bus = null;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/ride/captainInfo/captainInfo.controller.js